let header,
    sticky,
    hideRightMessage;

const rightMessage = document.querySelector('.right-message');

window.onscroll = function () {
    header = document.getElementById("header");
    sticky = header.offsetTop;
    stickyHeader();
    toggleRightMessage();
};

function stickyHeader() {
    if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
    } else {
        header.classList.remove("sticky");
    }
}

function toggleRightMessage() {
    hideRightMessage = window.pageYOffset > 0;

    if (hideRightMessage) {
        try {
            rightMessage.classList.add("hide");
        } catch (error) {

        }
    } else {
        try {
            rightMessage.classList.remove("hide");
        } catch (error) {

        }
    }
}